import { render, staticRenderFns } from "./StudioEventTypeComponent.vue?vue&type=template&id=f9cdc04a&scoped=true&"
import script from "./StudioEventTypeComponent.vue?vue&type=script&lang=js&"
export * from "./StudioEventTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudioEventTypeComponent.vue?vue&type=style&index=0&id=f9cdc04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cdc04a",
  null
  
)

export default component.exports